import React from "react";
import Types from "prop-types";
import LanguageSelector from "../LanguageSelector";
import { ReCaptcha } from "../Guard";
import { Trans, withTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import PhoneNumber from "../common/PhoneNumber";
import AppleButton from "../common/AppleButton";
import FacebookButton from "../common/FacebookButton";

// signup flow types:
export const SIGNUP_WITH_PHONE = "phone";
export const SIGNUP_CORPORATE = "corporate";
export const SIGNUP_WITH_APPLE = "apple";
export const SIGNUP_WITH_FACEBOOK = "facebook";

export class SignupForm extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = props.onChange;
    this.onPhoneChange = props.onPhoneChange;
    this.onSubmit = props.onSubmit;
    this.state = {
      nameProvided: false,
    };
    this.nameField = React.createRef();
  }

  onAppleIdChange(props) {
    let { proofToken, appleIdToken, fullname, email, error } = props;
    this.props.onAppleIdChange(props);

    if (appleIdToken) {
      this.setState({
        nameProvided: fullname?.length > 0,
      });
    }
  }

  onFacebookTokenChange(props) {
    let { proofToken, facebookToken, fullname, email, error } = props;
    this.props.onAppleIdChange(props);

    if (facebookToken) {
      this.setState({
        nameProvided: fullname?.length > 0,
      });
    }
  }

  formHeader() {
    const { t, flowType } = this.props;
    switch (flowType) {
      case SIGNUP_CORPORATE:
      case SIGNUP_WITH_PHONE:
        return t("signup:title");
      case SIGNUP_WITH_APPLE:
        return t("signup:continue_with_apple");
      case SIGNUP_WITH_FACEBOOK:
        return t("signup:continue_with_facebook");
    }
  }

  render() {
    const { t, error, submitting, visibleFields, fullname, email } = this.props;
    return (
      <form onSubmit={this.onSubmit}>
        <Helmet>
          <title>Signup | Careem</title>
        </Helmet>

        <LanguageSelector />
        <h1> {this.formHeader()} </h1>
        <h3 />

        {error && <div className="invalid show">{error}</div>}

        {visibleFields.fullname && (
          <div className="material-form-field">
            <input
              type="text"
              autoFocus={visibleFields.fullname}
              autoComplete="off"
              id="fullname"
              name="fullname"
              required
              onChange={this.onChange}
              value={fullname}
            />
            <label className="material-form-field-label" htmlFor="fullname">
              {t("signup:full_name")}
            </label>
          </div>
        )}

        {visibleFields.phone && (
          <div className="material-form-field">
            <PhoneNumber onPhoneChange={this.onPhoneChange} />
          </div>
        )}

        {visibleFields.email && (
          <div className="material-form-field">
            <input
              type="email"
              autoComplete="off"
              id="email"
              name="email"
              value={email}
              onChange={this.onChange}
            />
            <label className="material-form-field-label" htmlFor="email">
              {t("signup:email")}
            </label>
          </div>
        )}

        {visibleFields.password && (
          <div className="material-form-field">
            <input
              autoComplete="off"
              autoFocus={
                !visibleFields.fullname &&
                !visibleFields.phone &&
                !visibleFields.email &&
                visibleFields.password
              }
              type="password"
              id="password"
              name="password"
              onChange={this.onChange}
            />
            <label className="material-form-field-label" htmlFor="password">
              {t("signup:password")}
            </label>
          </div>
        )}

        {visibleFields.invitationCode && (
          <div className="material-form-field">
            <input
              type="text"
              autoComplete="off"
              id="invitationCode"
              name="invitationCode"
              onChange={this.onChange}
            />
            <label
              className="material-form-field-label"
              htmlFor="invitationCode"
            >
              {t("signup:invitation_code")}
            </label>
          </div>
        )}

        <div className="signup-terms-text">
          <Trans i18nKey="signup:terms_statement" t={t}>
            By clicking on 'Sign up' you agree to Careem's
            <a href="https://www.careem.com/en-ae/terms/" target="_blank">
              Terms of Service
            </a>
            and acknowledge that you have read the
            <a href="https://www.careem.com/en-ae/privacy/" target="_blank">
              Privacy Policy
            </a>
            .
          </Trans>
        </div>
        <input
          className="btn-careem"
          type="submit"
          value={submitting ? t("common:please_wait") : t("signup:button")}
          name="verify-recover-btn"
          disabled={submitting}
        />

        <div
          id="alternative-login"
          style={{
            display:
              visibleFields.appleButton || visibleFields.facebookButton
                ? "block"
                : "none",
          }}
        >
          <div id="or">{t("common:or")}</div>
          {visibleFields.appleButton && (
            <AppleButton onChange={this.onAppleIdChange.bind(this)} />
          )}

          {visibleFields.facebookButton && (
            <FacebookButton
              onChange={this.onFacebookTokenChange.bind(this)}
              facebookToken={this.props.facebookToken}
            />
          )}
        </div>

        <p className="footer-link col-xs-12">
          {t("signup:careeem_terms_statement")}&nbsp;
          <a href="https://www.careem.com/terms" target="_blank">
            {t("signup:terms_conditions")}
          </a>
        </p>

        <ReCaptcha />
      </form>
    );
  }
}

SignupForm.propTypes = {
  t: Types.func.isRequired,
  visibleFields: Types.object.isRequired,
  onAppleIdChange: Types.func.isRequired,
  onChange: Types.func.isRequired,
  onPhoneChange: Types.func.isRequired,
  onSubmit: Types.func.isRequired,
};

export default withTranslation()(SignupForm);
